export const businessPlanPages = ["Milestones", "sprint-analytics"]
export type BillingInterval = "month" | "year"
export type ProductName = "Team" | "Business" | "Enterprise"
//type ProductType = 'service' | 'good';
type UsageType = "licensed" | "metered"
type MeterType = "licensed"

export const typesOfSubscriptionFeatures = [
  "productMilestones",
  "unlimitedProjects",
  "multiProjectTeams",
  "aiForcecasting",
  "jiraImport",
  "backlogAnalytics",
  "sprintAnalytics",
  "itemAnalytics",
  "teamsHealthCheck",
  "teamInsights",
  "support",
  "timesheets",
  "jira",
  "permissions",
  "enterpriseApi",
  "audit",
  "training",
  "support"
]

export type TypeOfSubscriptionFeatures = (typeof typesOfSubscriptionFeatures)[number]

interface StripeRecurring {
  interval: BillingInterval
  intervalCount: number
  meter?: MeterType
  usageType: UsageType
}

export interface Price {
  currency: string
  id: string
  recurring: StripeRecurring
  unitAmount: number
  unitAmountDecimal: number
}

export interface Recurring {
  interval: BillingInterval
  intervalCount: number
  meter: string
  trialPeriodDays: number
  usageType: string
}

export interface StripeProduct {
  description: string
  id: string
  name: string
  price: Price
  type: string
  url: string
}

export interface StripePrice {
  productId: string
  productName: ProductName
  price: number
  priceId: string
  recurring: Recurring
}

export interface PaymentRequest {
  amount: number
  currency: string
  customerDetails: {
    address: string
    name: string
    phone: string
  }
  metadata: {
    userId: string
  }
  paymentMethodId: string
}

export enum PaymentSubscriptionType {
  TEAM_MONTH = "TEAM_MONTH",
  TEAM_YEAR = "TEAM_YEAR",
  BUSINESS_MONTH = "BUSINESS_MONTH",
  BUSINESS_YEAR = "BUSINESS_YEAR",
  ENTERPRISE = "ENTERPRISE"
}

export interface PaymentSubscription {
  clientSecret: string
  sessionId: string
}
